import { render, staticRenderFns } from "./subjectWiseProbableData.vue?vue&type=template&id=0dea1ade&scoped=true&"
import script from "./subjectWiseProbableData.vue?vue&type=script&lang=js&"
export * from "./subjectWiseProbableData.vue?vue&type=script&lang=js&"
import style0 from "./subjectWiseProbableData.vue?vue&type=style&index=0&id=0dea1ade&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea1ade",
  null
  
)

export default component.exports